var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.864746,
    y: 1.16895,
    width: 23,
    height: 23,
    rx: 7.5,
    fill: "#FCF1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.864746,
    y: 1.16895,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#FEE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6772 15.958C15.8882 16.1924 15.8882 16.5439 15.6772 16.7549C15.4429 16.9893 15.0913 16.9893 14.8804 16.7549L12.1147 13.9658L9.32568 16.7549C9.09131 16.9893 8.73975 16.9893 8.52881 16.7549C8.29443 16.5439 8.29443 16.1924 8.52881 15.958L11.3179 13.1689L8.52881 10.3799C8.29443 10.1455 8.29443 9.79395 8.52881 9.58301C8.73975 9.34863 9.09131 9.34863 9.30225 9.58301L12.1147 12.3955L14.9038 9.60645C15.1147 9.37207 15.4663 9.37207 15.6772 9.60645C15.9116 9.81738 15.9116 10.1689 15.6772 10.4033L12.8882 13.1689L15.6772 15.958Z",
    fill: "#B91C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.1c2186f9e571af7f4d19beb830da4151.svg";
export { ForwardRef as ReactComponent };